import Base from '@studiometa/js-toolkit';
import withBreakpointManager from '@studiometa/js-toolkit/decorators/withBreakpointManager';
import MarquesMobile from './MarquesMobile';
import MarquesDesktop from './MarquesDesktop';

/**
 * Homepage class.
 */
export default class Marques extends withBreakpointManager(Base, [
  ['xs sm md', MarquesMobile],
  ['lg xl xxl', MarquesDesktop],
]) {
  static config = {
    name: 'Marques',
    refs: ['wrapper', 'slides[]'],
  };
}
